import useSWR from "swr";

import { useManageApiHeaders } from "@is/hooks/useManageApiHeaders";
import { api, createBasketUrl } from "@is/services";
import { BasketItem } from "@is/types";

type BasketResponse = {
  items: BasketItem[];
  totalItems: number;
  totalPrice: number;
};

type Options = {
  [key: string]: boolean | number;
};

export const useBasket = (options: Options = {}) => {
  const { setApiHeaders, sessionId } = useManageApiHeaders();

  setApiHeaders();

  const url = createBasketUrl();

  const { data, error, isLoading } = useSWR(
    sessionId ? [url, sessionId] : null,
    ([u]) => api.get(u),
    options
  );

  return {
    basketItems: (data as BasketResponse)?.items || null,
    totalItems: (data as BasketResponse)?.totalItems || 0,
    totalPrice: (data as BasketResponse)?.totalPrice || 0,
    error,
    isLoading,
  };
};
